import DueDatePicker from "@/components/DueDatePicker/dueDatePicker.component";
import {
  format,
  isPast,
  isThisYear,
  isToday,
  isTomorrow,
  isYesterday,
  parseISO,
} from "date-fns";
import React, { ReactNode } from "react";

type TaskCellDueDateProps = {
  dueDate: string | null;
  className: string;
  editedDueDate?: string;
  editing: boolean;
  handleFieldDueDate?: (value: Date | undefined | null) => void;
  createDueDateOpen?: React.MutableRefObject<boolean>;
};

const TaskCellDueDate: React.FC<TaskCellDueDateProps> = ({
  dueDate,
  className,
  editedDueDate,
  editing,
  handleFieldDueDate,
  createDueDateOpen,
}) => {
  function formatCellDate(date: string | null): ReactNode {
    if (!date) return <div className="">No Due Date</div>;

    const parsedDate = parseISO(date);
    let dateShown;
    let colorClass = "";
    if (isToday(parsedDate)) {
      colorClass = "text-green-400";
      dateShown = "Today";
    } else if (isTomorrow(parsedDate)) {
      colorClass = "text-indigo-400";
      dateShown = "Tomorrow";
    } else if (isPast(parsedDate)) {
      colorClass = "text-red-400";
      if (isYesterday(parsedDate)) {
        dateShown = "Yesterday";
      }
    }

    if (isThisYear(parsedDate)) {
      dateShown = dateShown ?? format(parsedDate, "yyy/MM/dd");
    } else {
      dateShown = dateShown ?? format(parsedDate, "yyy/MM/dd");
    }

    return <div className={`${colorClass}`}>{dateShown}</div>;
  }

  return editing && handleFieldDueDate ? (
    <div className={className}>
      <DueDatePicker
        dueDate={editedDueDate ? new Date(editedDueDate) : null}
        onDateChange={handleFieldDueDate}
        modal={false}
        createDueDateOpen={createDueDateOpen}
      />
    </div>
  ) : (
    <div className={className}>{formatCellDate(dueDate)}</div>
  );
};

export default TaskCellDueDate;
